import React from 'react';
const AsyncContext = React.createContext({
  injectReducers: null,
  injectSagas: null,
});

export default AsyncContext;
